/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, {
  useMemo,
  useLayoutEffect,
  useEffect,
  useState,
  useContext,
} from "react";
import objectPath from "object-path";
import { Link, useLocation } from "react-router-dom";
import { BreadCrumbs } from "./components/BreadCrumbs";
import { IconBasket, IconLocation } from "../../../css/icons";
import ContextApp from "../../../../core/contexts/context.app";
import ServiceStorage from "../../../../core/services/service.storage";
import ApiRegion from "../../../../core/api/api.region"; // مطمئن شو مسیر درسته
import _ from "lodash";
import {
  getBreadcrumbsAndTitle,
  useSubheader,
} from "../../_core/MetronicSubheader";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import moment from "moment-jalaali";
import SelectCityModal from "./SelectCityModal";

export function SubHeader() {
  const uiService = useHtmlClassService();
  const location = useLocation();
  const subheader = useSubheader();
  const ctx = useContext(ContextApp);

  const [showModalSelectCity, setShowModalSelectCity] = useState(false);

  moment.loadPersian({ usePersianDigits: false, dialect: "persian-modern" });

  const layoutProps = useMemo(() => {
    return {
      config: uiService.config,
      subheaderMobileToggle: objectPath.get(
        uiService.config,
        "subheader.mobile-toggle"
      ),
      subheaderCssClasses: uiService.getClasses("subheader", true),
      subheaderContainerCssClasses: uiService.getClasses(
        "subheader_container",
        true
      ),
    };
  }, [uiService]);

  // ست کردن title و breadcrumb ها
  useLayoutEffect(() => {
    const aside = getBreadcrumbsAndTitle("kt_aside_menu", location.pathname);
    const header = getBreadcrumbsAndTitle("kt_header_menu", location.pathname);
    const breadcrumbs =
      aside && aside.breadcrumbs.length > 0
        ? aside.breadcrumbs
        : header.breadcrumbs;
    subheader.setBreadcrumbs(breadcrumbs);
    subheader.setTitle(
      aside && aside.title && aside.title.length > 0
        ? aside.title
        : header.title
    );
    // eslint-disable-next-line
  }, [location.pathname]);

  // گرفتن لیست شهرها و انتخاب پیش‌فرض
  useEffect(() => {
    const initCity = async () => {
      if (!ServiceStorage.getSelectedCity()) {
        try {
          const res = await ApiRegion.getRegions();

          if (res?.length > 0) {
            const firstCity = res[0];

            // آپدیت Context
            ctx.setSelectedCity(firstCity);

            // ذخیره در استوریج
            ServiceStorage.setSelectedCity(firstCity);
            ServiceStorage.setCity({
              cityListLastUpdate: new Date(),
              cityList: res.data,
              selectedCity: firstCity,
            });
          }
        } catch (error) {
          console.error("خطا در گرفتن لیست شهرها", error);
        }
      }
    };

    initCity();
  }, [ctx]);

  return (
    <>
      {showModalSelectCity && (
        <SelectCityModal
          showModalSelectCity={showModalSelectCity}
          setShowModalSelectCity={setShowModalSelectCity}
        />
      )}
      <div
        id="kt_subheader"
        className={`subheader py-2 py-lg-4 ${layoutProps.subheaderCssClasses}`}
      >
        <div
          className={`${layoutProps.subheaderContainerCssClasses} d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap`}
        >
          {/* Info */}
          <div className="d-flex align-items-center flex-wrap mr-1">
            {layoutProps.subheaderMobileToggle && (
              <button
                className="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none"
                id="kt_subheader_mobile_toggle"
              >
                <span />
              </button>
            )}

            <div className="d-flex align-items-baseline mr-5">
              <h5 className="text-dark font-weight-bold my-2 mr-5">
                {subheader.title}
              </h5>
            </div>

            <BreadCrumbs items={subheader.breadcrumbs} />
          </div>

          {/* Toolbar */}
          <div className="d-flex align-items-center">

            {ctx?.selectedCity && <div 
              className="btn btn-outline-danger btn-sm ms-2"
              onClick={() => {
                setShowModalSelectCity(true);
              }}
            >
              <IconLocation width="16px" />
              <span className="text-truncate-1-line fw-bold fs-075">
                {ctx?.selectedCity?.name || "انتخاب شهر"}
              </span>
            </div>}

            <Link
              to="/basket"
              className="btn btn-success btn-sm font-weight-bold ms-2 position-relative"
            >
              {_.filter(ctx.basketInfo?.basketItemTemps, { isDeleted: false })
                ?.length > 0 && (
                <div
                  className="bg-danger rounded-pill fs-small d-flex align-items-center justify-content-center"
                  style={{
                    width: "14px",
                    height: "14px",
                    position: "absolute",
                    top: "3px",
                    right: "3px",
                  }}
                >
                  {
                    _.filter(ctx.basketInfo?.basketItemTemps, {
                      isDeleted: false,
                    })?.length
                  }
                </div>
              )}
              <IconBasket width="16px" className="mx-1" />
              سبد خرید
            </Link>

            <div className="btn btn-light btn-sm font-weight-bold">
              <span className="text-primary font-weight-bold">
                {moment().format("jD-jMMMM-jYYYY")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
